export const employeesGroupsListKeys = {
  all: ["employees-groups-list"] as const,
  lists: () => [...employeesGroupsListKeys.all, "list"] as const,
  list: () => [...employeesGroupsListKeys.lists()] as const,
};
